import { PersonalizeProductComponent } from './../personalize-product/personalize-product';
import { ModalController, ViewController, NavParams } from 'ionic-angular';
import { HostService } from './../../providers/host/host.service';
// import { combineLatest } from 'rxjs';
import { PersonalizeMenuProductComponent } from '../personalize-menu-product/personalize-menu-product';
import { Component, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { Subject } from 'rxjs';
import { MenuService } from '../../providers/menu/menu.service';
import { OrdersService } from '../../providers/order/orders.service';
import { OptionsSuppComponent } from '../options-supp/options-supp.component';

@Component({
    selector: 'menu-modal',
    templateUrl: 'menu-modal.component.html'
})
export class MenuModalComponent {
    menu: any = {};
    menuCategory: string = "";
    config = {
        ignoreBackdropClick: true
    };
    subscriptions: Subscription[] = [];
    host = "";
    enableAddButton = false;
    goToNext: Subject<number> = new Subject<number>();
    chosenOrderType;
    activeF = 0;
    event;
    loader = true;
    tab = -1;
    tab2 = -1;
    orderProg;
    compositions:any[]=[];
    currency = "€";
    language = localStorage.getItem('language');
    constructor(
        private menuService: MenuService,
        private changeDetection: ChangeDetectorRef,
        private orderService: OrdersService,
        private hostService: HostService,
        private modalCtrl: ModalController,
        private viewCtr: ViewController,
        private viewCtrl: ViewController,
        params: NavParams
    ) {
        this.currency = localStorage.getItem('currency');
        this.host = this.hostService.host2;
        this.menu = params.get('menu');
        const subs6 = this.orderService.chosenOrderType.subscribe((chosenOrderType: number) => {
            this.chosenOrderType = chosenOrderType;
        });
        const subs9 = this.orderService.orderProg.subscribe((orderProg) => {
            this.orderProg = orderProg;
        });
    }
    PersonalizeModal(product, next) {
        if (product.available && (product.compositions.length > 0 || product.maxNbrIngOptions > 0 || product.hasSupp)) {
            let personnaliseProduct = this.modalCtrl.create(PersonalizeMenuProductComponent, { product: product });
            personnaliseProduct.present();
            personnaliseProduct.onDidDismiss(data => {
                if (data && next) {
                    // this.next();
                }
                this.unsubscribe();
            });
        }

    }
    ngOnInit() {
        setTimeout(
            () => {
                this.compositions=[];
                for(let j=0;j<11;j++){
                    let comp=this.menu.compositions.elements[j].concat(this.menu.compositions.families[j]);
                    this.compositions.push(comp);
                }
                this.menu.choix = [
                    { checked: false },
                    { checked: false },
                    { checked: false },
                    { checked: false },
                    { checked: false },
                    { checked: false },
                    { checked: false },
                ]
                this.menu.additionalOptions = [];
                this.menu.compositions2 = [];
                this.menuService.getMenuCompositions(this.menu.id, this.chosenOrderType,this.orderProg).subscribe(
                    (data: any) => {
                        this.loader = false;
                        this.menu.compositions2 = data;
                        this.menu.compositions2.forEach((compsition, ind) => {
                            if (ind > 0 && compsition.length > 0) {
                                compsition.checked = 0;
                            }
                            compsition.forEach(comp => {
                                if (comp.type == 2) {
                                    comp.elements.forEach((element, l) => {
                                        element.selectedElement = element.findIndex(e => e.available);
                                    });
                                }
                            });
                        });
                    }
                )
                this.menuService.getMenuAdditionalOptionss(this.menu.id).subscribe(
                    (data: any) => {
                        this.loader = false;
                        this.menu.additionalOptions = data.map(
                            addOpt => {
                                addOpt.text = addOpt.name + " ( " + addOpt.size + " " + addOpt.price + " " + this.currency + " )";
                                addOpt.disabled = (addOpt.available) ? false : true;
                                return addOpt;
                            }
                        )
                    }
                )
            }, 100
        )
    }

    setFamily(j, i) {
        this.menu.families[i].checked = j;
        this.activeF = j;
    }
    AddOptionsSupp(options) {
        let personnaliseProduct = this.modalCtrl.create(OptionsSuppComponent, { options: options });
        personnaliseProduct.present();
        personnaliseProduct.onDidDismiss(data => {
            if (data) {
                this.orderService.addMenu(this.menu).then(
                    (d) => {
                        this.viewCtr.dismiss();
                        this.menuService.nextPanel.next(false);
                    }, (err) => {
                    }
                ).catch(error => { });
            }
            this.unsubscribe();
        });
    }

    addToBasket() {
        if (this.menu.additionalOptions.length > 0) {
            this.AddOptionsSupp(this.menu.additionalOptions);
        } else {
            this.orderService.addMenu(this.menu).then(
                (d) => {
                    this.viewCtr.dismiss();
                    this.menuService.nextPanel.next(false);
                }, (err) => {
                }
            ).catch(error => { });
        }
    }
    next() {
        this.goToNext.next(1);
        this.tab = -1;
    }
    unsubscribe() {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
    }
    ngAfterViewChecked() {
        let en = this.event;
        if (en != this.enableAddButton) {
            this.enableAddButton = en;
            this.changeDetection.detectChanges();
        }
    }
    change(event) {
        this.event = event;
    }

    scrollHandler($event) {
        // let steps = <HTMLElement>document.getElementsByClassName('theme2')[0];
        // let scrollBody = document.getElementsByClassName('modal-body')[0].scrollTop;
        // if (scrollBody < 155) {
        //     steps.removeAttribute("style");
        // } else {
        //     if (this.offset(steps).top <= 0) {
        //         steps.style.position = "fixed";
        //         steps.style.zIndex = "50";
        //         steps.style.left = "0";
        //         steps.style.width = "100%";
        //     }
        // }
    }

    offset(obj) {
        var rect = obj.getBoundingClientRect();
        var win = obj.ownerDocument.defaultView;
        return {
            top: rect.top + win.pageYOffset
        };
    }
    closeModal() {
        this.viewCtrl.dismiss();
    }
    tabEvent(n, j) {
        switch (n) {
            case 1: {
                this.tab2 = -1;
                this.tab = (this.tab == j) ? -1 : j;
                break;
            }
            case 2: {
                this.tab2 = (this.tab2 == j) ? -1 : j;
            }
                break;
        }

    }
    // nextPanel(){
    //     // this.menuService.nextPanel.next(true);
    // }
}


// WEBPACK FOOTER //
// ./src/components/menu-modal/menu-modal.component.ts